export default __webpack_public_path__ + "images/C1.27b6cba.png";